module.exports = __webpack_public_path__ + "static/media/movie.4d9415ae.svg";